<template>
    <div class="d-flex add-image bg-medium pointer p-5 radius-top-left-normal radius-top-right-normal" :style="'background-image : url('+bannerBackground+')'" @click.stop="upload">
        <div class="d-flex flex-column align-items-center">
            <button class="btn secondary" type="button" @click.stop="upload">
                Edit Picture
            </button>
            <div class="fs-small dark mt-2 text-center">
                <div v-if="!isFormatOk">Image format must be JPG or PNG.</div>
                <div v-if="!isSizeOk">Image max size is {{sizeLimit}}Mb.</div>
            </div>
            <input type="file" class="hidden" ref="inputAvatarUpload" @change="receiveImage" />
        </div>

    </div>
</template>

<script>
export default {
    data: function() {
        return {
            newImageBase64: null,
            sizeLimit: 3, // in Mb
            validTypes:[
                'image/jpeg',
                'image/png'
            ],
            isSizeOk: true,
            isFormatOk: true,
            imageUploaded: false
        }
    },
    props: {
        currentImage:{
            type: String,
            default: null
        }
    },
    computed: {
        bannerBackground: function() {
            if(!this.imageUploaded){
                return this.currentImage;
            } else {
                return (this.newImageBase64)? this.newImageBase64 : null;
            }
        }
    },
    methods: {
        upload: function() {
            this.$refs.inputAvatarUpload.click();
        },
        receiveImage: function(event) {
            let vm = this;
            var reader = new window.FileReader() // if window is not used it says File READER is not defined

            // validate
            this.isFormatOk = this.validateType(event.target.files[0].type, this.validTypes)

            this.isSizeOk = this.validateSize(event.target.files[0].size, this.sizeLimit)

            if(this.isFormatOk && this.isSizeOk){
                reader.onload = function (event) {

                  // dispatch fileAttached to state UI postEditor with event.target.result as read dataURL
                  let imageDataBase64 = event.target.result
                  vm.imageUploaded = true;
                  vm.newImageBase64 = imageDataBase64;

                  vm.$emit('imageChanged', imageDataBase64);
                }
                reader.readAsDataURL(event.target.files[0])
            }

            //debug
            //console.log(event.target.files[0]);
        },
        validateType: function(receivedType, validTypesArr) {
            let output = false;
            for (let validType of validTypesArr) {
                if (receivedType == validType) {
                    output = true;
                }
            }
            return output
        },
        validateSize: function(givenSize, validSize){
            let sizeInMb = givenSize / (1024*1024);
            return sizeInMb <= validSize
        }
    }
}
</script>

<style lang="scss" scoped>
    .add-image {
        height: 21rem;
        background-position: center;
        background-size: cover;

        .btnEditPic{

        }
    }
</style>



// WEBPACK FOOTER //
// ProductAddImage.vue?7752f7be